import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

function TooltipedIconButton({
  id, text, onClick, icon, className,
}) {
  return (
    <>
      <UncontrolledTooltip placement="auto" target={id}>
        {text}
      </UncontrolledTooltip>
      <button
        id={id}
        type="button"
        className={className}
        onClick={onClick}
      >
        <i className={icon} />
      </button>
    </>
  );
}

TooltipedIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default TooltipedIconButton;
